import React from 'react';
import BuySellEdgeLogo from '../../../assets/images/buy-sell-edge.svg';
import ConnectNetworkResourceLogo from '../../../assets/images/connect-network-resource.svg';
import ManageNetworkResourceLogo from '../../../assets/images/manage-network-resource.svg';
import Edge from './Edge';
import PdfViewer from '../../PdfViewer';
import { MY_SELLER_BUCKET_PRE_URL } from '../../../utils/apiConstants';
import { OpenCloseHookProps } from '../../../utils/hooks/OpenCloseHook';

export interface EdgesInteraface {
  pdfOpen: OpenCloseHookProps
}

const Edges: React.FC<EdgesInteraface> = ({ pdfOpen }) => {
  return (
    <div className="edges">
      {/* <Edge pdfOpen={pdfOpen} text="Cloud Management"/> */}
      <Edge pdfOpen={pdfOpen} text="256x256 User Ports"/>
      {/* <Edge pdfOpen={pdfOpen} text="Switch Specifics" />
      <Edge pdfOpen={pdfOpen} text="Terms & Conditions" /> */}
    </div>
  );
};

export default Edges;
